module.exports = __webpack_public_path__ + "static/img/6areaA_8.f9df077.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/6areaA_8.png
// module id = 910
// module chunks = 1